import * as NavConstants from 'constants/NavConstants';
import {Optional} from 'util/Types';

import type {ChatDraftState} from '../ChatDraftState';

function getClientStateModule(): {
  openExistingChat: (chatSessionId: string) => void;
  openDraftChat: (draftState: ChatDraftState, options: {modal?: Optional<string>}) => void;
} {
  // This avoids a circular dependency in react-render.bundle.js.
  return require('./AISidepanelV2GlobalClientState');
}

export function openChat(chatSessionId: string): void {
  // This avoids a circular dependency in react-render.bundle.js.
  const SidepanelActions = require('nav/sidepanel/SidepanelActions');
  getClientStateModule().openExistingChat(chatSessionId);
  SidepanelActions.expandSection(NavConstants.SECTIONS.AI);
}

export function openDraftChat(draftState: ChatDraftState, options: {modal?: Optional<string>} = {}): void {
  getClientStateModule().openDraftChat(draftState, options);
}
